<template>
  <div>
    <!-- 从试卷添加考生 -->
    <div class="examinee_view">
      <el-dialog
        title="从试卷添加考生"
        :visible.sync="dialogVisibleObj.addexaminPaperShow"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <div class="examinee_head">
          <!-- 进度条 -->
          <div class="stepcontent">
            <div
              class="stepitem"
              v-for="(item, index) in progressbartitle"
              :key="index"
              :class="{ steptwo: isActive < index }"
            >
              <span>{{ index + 1 }}{{ item }}</span>
            </div>
          </div>
        </div>
        <!-- 第一步结构 -->
        <div class="examinee_mian" :class="{ isnoshow: isActive !== 0 }">
          <div class="examinee_input">
            <el-form
              :label-position="labelPosition"
              label-width="80px"
              :model="formExamin"
              ref="formExamin"
            >
              <el-form-item label="考试名称：" prop="name">
                <el-input
                  v-model.trim="formExamin.name"
                  placeholder="请输入考试名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="考试时间：" prop="examBeginDate">
                <div class="block">
                  <el-date-picker
                    @change="getDataList"
                    v-model.trim="examTime"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="考试开始日期"
                    end-placeholder="考试结束日期"
                  >
                  </el-date-picker>
                </div>
              </el-form-item>

              <el-form-item label="考试状态：" prop="examStatus">
                <el-select
                  v-model.trim="formExamin.examStatus"
                  placeholder="全部"
                  @change="changSearch"
                >
                  <el-option
                    v-for="item in examStatusArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="query_btn">
              <el-button
                type="primary"
                icon="el-icon-search"
                class="searchbtn"
                @click="searchBtn"
                >搜索</el-button
              >
              <el-button
                icon="el-icon-refresh"
                class="searchbtn sonbtn"
                @click="resetForm('formExamin')"
                >重置</el-button
              >
            </div>
          </div>
          <div class="examinee_fomr">
            <p>
              温馨提示：考生参加多场考试，考试记录均会显示，但只会添加一次。
            </p>
            <el-table
              :data="getData"
              style="width: 100%"
              :row-class-name="tableRowClassName"
              @selection-change="handleSelectionChange"
              :cell-class-name="stateColor"
              :row-key="getRowKeyOfTarget"
              :header-cell-style="{
                'background-color': '#8FCBFF',
                color: '#333333',
                height: '60px',
              }"
              v-loading="loading"
            >
              <el-table-column
                type="selection"
                width="80"
                :reserve-selection="true"
              ></el-table-column>
              <el-table-column label="序号" width="50">
                <template slot-scope="scope">
                  {{ scope.$index + 1 + currentPage3 * pageSize }}
                </template>
              </el-table-column>
              <el-table-column
                v-for="(item, index) in formColumns"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
                height="150"
                label-height="50"
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="foot_box">
            <div class="foot_pagetions">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="showpageindex"
                :page-size="pageSize"
                :page-sizes="pagesizesarr"
                layout="prev, pager, next,sizes, jumper"
                :total="total"
                class="pagination"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <!-- 第二部结构 -->
        <div class="examinee_mian" :class="{ isnoshow: isActive !== 1 }">
          <div class="examinee_input">
            <el-form
              :label-position="labelPosition"
              label-width="80px"
              :model="formAccount"
              ref="formAccount"
            >
              <el-form-item label="考生姓名：" prop="name">
                <el-input
                  v-model.trim="formAccount.name"
                  placeholder="请输入考生姓名"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="考生账号：" prop="account">
                <el-input
                  v-model="formAccount.account"
                  placeholder="请输入考生姓名"
                ></el-input>
              </el-form-item> -->
              <el-form-item label="成绩：" prop="results" class="aa">
                <el-select
                  v-model="formAccount.results"
                  placeholder="全部"
                  @change="isChangSearch"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="及格" value="2"></el-option>
                  <el-option label="不及格" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="归属考试：" prop="attribution">
                <el-input
                  v-model.trim="formAccount.attribution"
                  placeholder="请输入归属考试"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="query_btn">
              <el-button
                type="primary"
                icon="el-icon-search"
                class="searchbtn"
                @click="isSearchBtn"
                >搜索</el-button
              >
              <el-button
                icon="el-icon-refresh"
                class="searchbtn sonbtn"
                @click="resetFormTow('formAccount')"
                >重置</el-button
              >
            </div>
          </div>
          <div class="examinee_fomr">
            <p>
              温馨提示：考生参加多场考试，考试记录均会显示，但只会添加一次。
            </p>
            <p>已选{{ numberOf.length }}人，科室{{ this.unique() }}个</p>
            <el-table
              ref="multipleTable"
              :data="addData"
              style="width: 100%"
              :cell-class-name="stateColor"
              :row-class-name="tableRowClassName"
              @select="handleSelectionChange2"
              @select-all="handleSelectionChange2"
              :header-cell-style="{
                'background-color': '#8FCBFF',
                color: '#333333',
                height: '60px',
              }"
              v-loading="loading2"
            >
              <el-table-column type="selection" width="80"></el-table-column>
              <el-table-column label="序号">
                <template slot-scope="scope">
                  {{ scope.$index + 1 + currentPage2 * pageSize2 }}
                </template>
              </el-table-column>
              <el-table-column
                v-for="(item, index) in formSonColumns"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
                height="150"
                label-height="50"
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="foot_box">
            <div class="foot_pagetions">
              <el-pagination
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
                :current-page.sync="showpageindexTow"
                :page-size="pageSize2"
                :page-sizes="pagesizesarr2"
                layout="prev, pager, next,sizes, jumper"
                :total="total2"
                class="pagination"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="previousstep">{{
            isActive == 0 ? "取消" : "上一步"
          }}</el-button>
          <el-button type="primary" @click="nextstep">{{
            isActive == 1 ? "确定" : "下一步"
          }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 为空拦截 -->
    <div class="empty_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="qrdialogVisible"
        :close-on-click-modal="false"
      >
        <p>请选择试卷</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="qrdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="qrdialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getexamList, SearchExam, getStudentList } from "@/api/index.js";
import loginvuex from "@/store/index";
import qs from "qs";
export default {
  data() {
    return {
      isActive: 0, //第一步
      loading: true,
      loading2: true,
      dialogVisibleObj: {
        addexaminPaperShow: false, // 从试卷添加考生
      },
      progressbartitle: [
        //当这个length等于5的时候，就可以对进度条进行控制了。
        ".选择试卷",
        ".选择考生",
      ],
      labelPosition: "right",
      examTime: "", // 查询时间的v-model
      formExamin: {
        name: "", // 查询名称
        examStatus: "", // 考试状态查询
        examBeginDate: "", // 开始时间
        examEndDate: "", // 结束时间
      },
      selected: false, //判断是否选中
      showpageindex: 1, //显示的索引盒子
      showpageindexTow: 1, //显示的索引盒子
      examStatusArr: [
        {
          label: "全部",
        },
        {
          value: "0",
          label: "待考试",
        },
        {
          value: "1",
          label: "考试中",
        },
        {
          value: "2",
          label: "考试结束",
        },
      ],
      formAccount: {
        name: "",
        account: "",
        results: "",
        attribution: "",
      },
      getCondition: {
        name: "",
        attribution: "",
      },
      getDataCondition: {
        name: "",
      },
      getData: [],
      examIDArr: [], //试卷id数组
      formColumns: [
        {
          prop: "ExamName",
          label: "考试名称",
        },
        {
          prop: "BeginTime1",
          label: "考试时间",
        },
        {
          prop: "IsPublish1",
          label: "考试状态",
        },
        {
          prop: "AlreadyStuCount",
          label: "已考人数(人)",
        },
        {
          prop: "StudentCount1",
          label: "待考人数(人)",
        },
      ],
      addData: [],
      formSonColumns: [
        {
          prop: "RealName",
          label: "考生姓名",
        },
        {
          prop: "UserName",
          label: "考生账号",
        },
        {
          prop: "DepartmentName",
          label: "科室名称",
        },
        {
          prop: "CurMode1",
          label: "考试状态",
        },
        {
          prop: "Score",
          label: "成绩",
        },
        {
          prop: "ExamName",
          label: "归属考试",
        },
      ],
      multipleSelection: [],
      multipleSelectionIds: [],
      multipleSelectionCount: 0,
      multipleSelection2: [], // 添加考生数组
      currentPage3: 0, //  当前页数
      pageSize: 5,
      total: 100,
      pagesizesarr: [5, 10, 20, 50, 100,300,500],
      currentPage2: 0, //  当前页数 第二结构
      pageSize2: 5,
      total2: 100,
      pagesizesarr2: [5, 10, 20, 50, 100],
      qrdialogVisible: false, // 为空拦截弹窗
      isnowselectdate: {}, //当前选中的数据对象数组。
      isselectstudent: "", //选中的考生信息
      isslectstudentnum: "", //选中考生总人数
      numberOf: [],
      warnType:0, // 警告提示
    };
  },
  methods: {
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // chang搜索   ===> 试卷搜索
    changSearch() {
      this.currentPage3 = 0;
      this.loading = true;
      this.getDataList();
    },
    // chang搜索   ===> 考生搜索
    isChangSearch() {
      this.currentPage2 = 0;
      this.loading2 = true;
      this.determineExam();
    },
    // 搜索   ===> 试卷搜索
    searchBtn() {
      this.currentPage3 = 0;
      this.loading = true;
      if (this.formExamin.name) {
        this.getDataCondition.name = this.formExamin.name;
      } else {
        this.getDataCondition.name = "";
      }
      this.getDataList();
    },
    // 考生搜索
    isSearchBtn() {
      this.currentPage2 = 0;
      this.loading2 = true;
      if (this.formAccount.name) {
        this.getCondition.name = this.formAccount.name;
      } else {
        this.getCondition.name = "";
      }
      if (this.formAccount.attribution) {
        this.getCondition.attribution = this.formAccount.attribution;
      } else {
        this.getCondition.attribution = "";
      }
      this.determineExam();
    },
    // 重置
    resetForm(formExamin) {
      this.$refs[formExamin].resetFields();
      this.currentPage3 = 0;
      this.showpageindex = 1;
      this.examTime = "";
      this.formExamin.examBeginDate = "";
      this.formExamin.examEndDate = "";
      this.getDataCondition.name = "";
      this.loading = true;
      this.getDataList();
    },
    resetFormTow(formAccount) {
      this.$refs[formAccount].resetFields();
      this.currentPage2 = 0;
      this.showpageindexTow = 1;
      this.loading2 = true;
      this.getCondition.name = "";
      this.getCondition.attribution = "";
      this.determineExam();
    },
    // 去重复
    unique() {
      let departArr = Object.values(this.numberOf)
        .flat(2)
        .map((item) => {
          return item.DepartmentName;
        });
      departArr = [...new Set(departArr)];
      return departArr.length;
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.loading = true;
      this.getDataList(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage3 = val - 1;
      this.loading = true;
      this.getDataList(); // 重新发起请求
    },
    // 第二步分页
    handleSizeChange2(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize2 = val;
      this.loading2 = true;
      this.determineExam();
    },
    handleCurrentChange2(val) {
      console.log(`当前页: ${val}`);
      this.currentPage2 = val - 1;
      this.loading2 = true;
      console.log(this.isnowselectdate);
      this.determineExam();
    },
    pageData: (number, pageSize, data) => {
      const pageList = [];
      const start = pageSize * number - pageSize;
      const end = pageSize * number;
      for (let i = start; i < end; i++) {
        pageList.push(data[i]);
      }
      const list = pageList.filter((item) => item);
      return list;
    },
    getRowKeyOfTarget(row) {
      return row.ExamID;
    },
    handleSelectionChange(val) {
      // 选中，多量操作
      this.multipleSelectionIds = [];
      this.multipleSelection = val;
      this.multipleSelectionCount = 0;
      val.forEach((row) => {
        this.multipleSelectionIds.push(row.ExamID);
      });
      this.multipleSelection = val;
      this.multipleSelectionCount = this.multipleSelection.length;
    },
    handleSelectionChange2(val) {
      if (
        this.isnowselectdate[this.currentPage2] === undefined &&
        val.length == 0
      ) {
        return;
      }
      this.isnowselectdate[this.currentPage2] = val;
      console.log(Object.values(this.isnowselectdate).flat(2));
      this.numberOf = Object.values(this.isnowselectdate).flat(2);
      console.log(this.isnowselectdate, "数量");
    },

    // 考试状态
    examisState() {
      this.addData = this.addData.map((item) => {
        if (item.examState === 0) {
          item.examState = "未考试";
        } else if (item.examState === 1) {
          item.examState = "已考试";
        }
        return item;
      });
    },
    // 表格样式设置
    stateColor({ row, column, rowIndex, columnIndex }) {
      if (row.IsPublish1 === "考试中" && columnIndex === 4) {
        return "yellow";
      } else if (row.IsPublish1 === "考试结束" && columnIndex === 4) {
        return "red";
      } else if (row.IsPublish1 === "待考试" && columnIndex === 4) {
        return "green";
      }
    },
    // 成绩
    results() {
      this.addData = this.addData.map((item) => {
        if (item.results === 0) {
          item.results = "不及格";
        } else if (item.results === 1) {
          item.results = "及格";
        }
        return item;
      });
    },
    previousstep() {
      //为0的时候
      if (this.isActive === 0) {
        this.dialogVisibleObj.addexaminPaperShow = false;
        this.isActive = 0;
        this.cancel();
      } else {
        this.isActive--;
      }
      //为1的时候
    },
    nextstep() {
      //为0的时候
      if (this.isActive === 1) {
        this.dialogVisibleObj.addexaminPaperShow = false;
        this.isActive = 0;
        this.certain();
      } else {
        if (this.multipleSelection.length < 1) {
          this.qrdialogVisible = true;
        } else {
          this.isActive++;
          this.determineExam();
        }
      }
      //为1的时候
    },
    // 数据处理
    withData() {
      this.getData.map((item) => {
        item.BeginTime1 =
          this.$moment(item.BeginTime).format("YYYY/MM/DD HH:mm") +
          "-" +
          this.$moment(item.EndTime).format("YYYY/MM/DD HH:mm");
        // 时间处理
        if (item.BeginTime1 == "Invalid date-Invalid date") {
          item.BeginTime1 = "暂无";
        }
        // 考试状态
        if (item.BeginTime > item.ServerTime && item.IsPublish === 1) {
          item.IsPublish1 = "待考试";
        }
        if (
          item.BeginTime <= item.ServerTime &&
          item.IsPublish === 1 &&
          item.ServerTime < item.EndTime
        ) {
          item.IsPublish1 = "考试中";
        }
        if (item.ServerTime > item.EndTime && item.IsPublish === 1) {
          item.IsPublish1 = "考试结束";
        }
        // 代考人数的计算
        item.StudentCount1 = item.StudentCount - item.AlreadyStuCount;
        if (item.StudentCount1 < 0) {
          item.StudentCount1 = 0;
        }

        return item;
      });
    },
    // 添加试卷列表
    async getDataList() {
      if (this.examTime) {
        const time = JSON.parse(JSON.stringify(this.examTime));
        this.formExamin.examBeginDate = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formExamin.examEndDate = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      let parmas = {
        pageIndex: this.currentPage3,
        eachPageNum: this.pageSize,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        examName: this.getDataCondition.name,
        examStatus: this.formExamin.examStatus, //考试状态
        examBeginDate: this.formExamin.examBeginDate, //考试开始时间
        examEndDate: this.formExamin.examEndDate, //考试结束时间
        type: 0, //试卷类型 0考试,1练习,2纸质,3视频试卷
        hid: JSON.parse(loginvuex.state.hid),
      };
      this.currentPage3 = 0;
      const Data = await getexamList(parmas);
      if (Data.data.Status === 200) {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        this.getData = Data.data.Data.data;
        this.total = Data.data.Data.count;
        this.withData();
      }
      console.log(this.getData, "列表数据");
    },
    // 初始字段为空时状态
    isNotSet() {
      // 第一个表格
      this.getData.map((item) => {
        for (let ztiem in item) {
          if (item[ztiem] === "") {
            item[ztiem] = "未设置";
          }
        }
      });
      // 第二个表格
      this.addData.map((item) => {
        for (let ztiem in item) {
          if (item[ztiem] === "") {
            item[ztiem] = "未设置";
          }
        }
      });
    },
    examFn() {
      this.addData.map((item) => {
        item.Birthday1 = this.$moment(item.Birthday).format("YYYY/MM/DD HH:mm");
        if (item.Score == null) {
          item.Score = "-";
        }
        if (item.CurMode === 0) {
          item.CurMode1 = "未考试";
        } else if (item.CurMode === 1) {
          item.CurMode1 = "正在考试";
        } else if (item.CurMode === 2) {
          item.CurMode1 = "考试结束";
        } else if (item.CurMode === 3) {
          item.CurMode1 = "超时未答";
        }
      });
    },
    // 确定试卷添加考生
    async determineExam() {
      let parmas = {
        examIDArr: `[${this.multipleSelectionIds}]`,
        SearchString: this.getCondition.name, // 姓名查询
        ScoreStatus: this.formAccount.results, // 是否及格查询
        pageIndex: JSON.stringify(this.currentPage2), //这里之前是0改成1了
        pageShow: JSON.stringify(this.pageSize2),
        type: 0, //试卷类型 0考试,1练习,2纸质,3视频试卷
        examName: this.getCondition.attribution, // 归属考试查询
        ScoreStatus: this.formAccount.results, // 成绩查询是否及格
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
        key: "1",
      };
      const Data = await getStudentList(qs.stringify(parmas));
      if (Data.status === 200) {
        this.addData = Data.data.Data[0];
        this.total2 = Data.data.Data[1][0].total;
        setTimeout(() => {
          this.loading2 = false;
        }, 500);
        this.examFn(); //数据处理
      } else {
        this.$message.error("很抱歉，数据获取不到");
      }
    },
    cancel() {
      //取消按钮
      if (
        this.multipleSelection2 == "" ||
        this.multipleSelection2.length == 0
      ) {
        this.dialogVisibleObj.addexaminPaperShow = false;
      } else {
        this.dialogVisibleObj.addExamineeShow = false;
        this.isnowselectdate = {};
      }
    },
    certain() {
      //确定按钮
      const examState = sessionStorage.getItem('examState') // 是否是组卷进入
      let newobj = {};
      this.isselectstudent = Object.values(this.isnowselectdate).flat(2);
      this.isselectstudent = this.isselectstudent.filter((item) => {
        if (!newobj[item.UserID]) {
          newobj[item.UserID] = "1";
          return item;
        }
      });
      if (this.$parent.getData.length != 0) {
        let puseridarr = this.$parent.getData.map((item) => {
          return item.UserID;
        });
        let fileterisslecte = this.isselectstudent.filter((item) => {
          let res = puseridarr.findIndex((value) => value == item.UserID);
          return res == -1;
        });

        if (fileterisslecte.length == 0) {
          this.$message({
            message: "该考生已经添加了，请添加新的考生",
            type: "warning",
          });
          this.dialogVisibleObj.addexaminPaperShow = false;
        } else {
          // 只有组卷才触发
          if (this.isselectstudent.length >= 1500 && this.warnType == 0 && examState === 'true') {
            this.$alert(
              `尊敬的用户您好,检测到您配置的该考试人数超过1500人。为了给您提供更好更稳定的考生服务，请您联系销售人员，我们将竭诚为您提供更好的考试服务`,
              "温馨提示",
              {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.warnType = 1
                  return;
                },
              }
            );
            return;
          } 
            this.$parent.getData.push(...fileterisslecte);
            this.dialogVisibleObj.addexaminPaperShow = false;
         
        }
      } else {
        if (this.isselectstudent.length >= 1500 && this.warnType == 0 && examState === 'true') {
          this.$alert(
            `尊敬的用户您好,检测到您配置的该考试人数超过1500人。为了给您提供更好更稳定的考生服务，请您联系销售人员，我们将竭诚为您提供更好的考试服务`,
            "温馨提示",
            {
              confirmButtonText: "确定",
              callback: (action) => {
                this.warnType = 1
                return;
              },
            }
          );
          return;
        } 
          this.$parent.getData = this.isselectstudent;
          this.dialogVisibleObj.addexaminPaperShow = false;
      }

      this.$parent.getData = JSON.parse(JSON.stringify(this.$parent.getData));
    },
    toggleSelection(rows) {
      //选中的钩子回选的问题。
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(
            this.addData.find((item) => {
              return item.UserName == row.UserName && item.ExamID == row.ExamID;
            }),
            true
          );
        });
      }
    },
    inits() {
      //重置数据要放在父组件里面。
      Object.assign(
        this.$data,
        JSON.parse(JSON.stringify(this.$parent.AddExaminData))
      );
      //   this.examisState();
      // this.results();
      // this.isNotSet() // 初始字段为空
      this.dialogVisibleObj.addexaminPaperShow = true;
      this.examisState();
      this.results();
      this.isNotSet(); // 初始字段为空
      this.getDataList();
    },
  },
  created() {
    // this.rendersum = this.pageData(1, 5, this.getData); // 分页
    this.$parent.AddExaminData = JSON.parse(
      JSON.stringify(this.$options.data())
    );
    this.examisState();
    this.results();
    this.isNotSet(); // 初始字段为空
    this.getDataList();
  },
  computed: {
    newgetdata() {
      return JSON.parse(JSON.stringify(this.addData));
    },
  },
  watch: {
    newgetdata(newval, oldval) {
      this.$nextTick(() => {
        this.toggleSelection(this.isnowselectdate[this.currentPage2]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.examinee_view {
  box-sizing: border-box;
  .title_box {
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
    margin-bottom: 50px;
  }

  .el-dialog__footer span > button {
    margin-top: 10px;
    width: 103px;
    height: 42px;
  }
  ::v-deep .el-dialog {
    width: 1593px;
    // height: 688px;
    // overflow-y: scroll;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .el-dialog__header {
    padding: 0px 24px;
  }
  .examinee_head {
    height: 96px;
    //width: 100%;
    border-bottom: 1px solid #eeeeee;
    background-color: #64b5ff;
  }
  .examinee_mian {
    .examinee_input {
      padding: 20px 24px 10px 4px;
      display: flex;
      height: 88px;
      border: 1px solid #eeeeee;
      ::v-deep .el-form-item__label {
        width: 82px !important;
        margin-left: 24px;
      }
      ::v-deep .el-form-item__content {
        margin-left: 110px !important;
      }
      ::v-deep .el-form {
        display: flex;
      }
      .query_btn {
        display: flex;
        margin-left: 24px;
        .el-button {
          width: 88px;
          height: 40px;
          margin-left: 24px;
        }
      }
    }
    .examinee_fomr {
      padding: 24px 24px;
      p {
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 21px;
        color: #ffa200;
        opacity: 1;
        margin-bottom: 20px;
      }
    }
  }
}
::v-deep .delete_view .el-dialog {
  width: 496px;
  height: 546px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  line-height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
    &:nth-child(2) {
      margin-left: 90px;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-range-separator {
  color: #d9d9d9;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    //background-color: #333333;
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
.first {
  background-color: #333333;
}
.isnoshow {
  display: none;
}
.stepitem {
  height: 45px;
  background-color: #1890ff;
  border-radius: 45px 45px 45px 45px;
  overflow: hidden;
  position: relative;
  &:nth-child(1) {
    transform: translate(90px);
    z-index: 20;
    &::before {
      background-color: #1890ff;
    }
  }
  &:nth-child(2) {
    transform: translate(45px);
    z-index: 10;
  }
  &:nth-child(3) {
    //transform: translate(45px);
    z-index: 5;
  }
  &:nth-child(4) {
    transform: translate(-45px);
    z-index: 1;
  }
  &:nth-child(5) {
    transform: translate(-90px);
    z-index: 0.5;
  }
  &::before {
    display: inline-block;
    position: absolute;
    content: "";
    width: 60px;
    height: 60px;
    background-color: rgb(255, 255, 255);
    border-radius: 50% 50%;
    transform: translate(-8px, -7px);
  }
  span {
    display: inline-block;
    width: 100%;
    line-height: 45px;
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC;
    // font-weight: bold;
    color: #ffffff;
    padding-left: 71px;
    padding-right: 71px;
  }
}
.steptwo {
  background-color: #eeeeee;
  span {
    color: #bbbbbb !important;
  }
}
.stepcontent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 102px;
  // border-bottom-left-radius: 10px;
  // border-bottom-right-radius: 10px;
  // border-radius: 20% !important;
  background-color: #fff;
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ff0000;
  }
}
::v-deep .el-table .yellow .cell {
  color: #ffa200 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ffa200;
  }
}
::v-deep .el-table .green .cell {
  color: #00d254 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #00d254;
  }
}
.empty_view {
  ::v-deep .el-dialog {
    width: 400px !important;
    height: 200px !important;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .el-dialog__header {
    line-height: 20px !important;
  }
  p {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 74px;
    font-size: 16px;
  }
  .dialog-footer > button {
    margin-top: 0px !important ;
  }
}
.aa {
  margin-right: 30px !important;
}
::v-deep .el-table__body-wrapper {
  height: 240px;
  overflow-y: scroll;
  position: relative;
  scrollbar-face-color: none !important;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    //  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
  }
  & ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
  }
}
::v-deep .el-table__header-wrapper {
  position: sticky;
  top: 0;
}
</style>